<template>
  <main class="ly_main" role="main">
    <Header v-if="page != 'start'"/>
    <component :is="page"></component>
  </main>
</template>

<script>
import Header from '@/components/layout/Header';
import Start from '@/components/Start';
import SelectGrade from '@/components/SelectGrade';
import SelectStage from '@/components/SelectStage';
import Question from '@/components/Question';
import Result from '@/components/Result';
import Tutorial from '@/components/Tutorial';
import DataClear from '@/components/DataClear';
import Exit from '@/components/Exit';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    Header,
    Start,
    SelectGrade,
    SelectStage,
    Question,
    Result,
    Tutorial,
    DataClear,
    Exit,
  },
  computed: {
    ...mapState('currentPage', [
      'page',
    ]),
  },
};

</script>

<style lang="scss">

$pc: 1024px;
$sp: 768px;
html{
  height: 100%;
  width: 100%;
}
main{
  display: block;
}

body{
  // height: 100%;
  // width: 100%;
  color: #000;
  font-family: 'Noto Sans JP', sans-serif;
  background: url('/kids/quiz/static/image/bg_01.png') left top repeat;
  background-size: 375px auto;
}

ruby{
  > rt{
    transform: none;
    font-weight: normal;
    font-size: 8px;
  }
}

input[type=radio] {
  display: none;
}

.ly_main{
  height: 100%;
  overflow: visible;

  .ly_mainInner{
    padding: 90px 15px 15px;
    margin: 0 auto;
    height: 100%;
  }

  .el_btn{
    box-sizing: border-box;
    display: block;
    border-radius: 10px;
    border: 4px solid #fff;
    box-shadow: 1px 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #00abea;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    text-decoration: none;
    padding: 15px 12px 17px;
    width: 100%;
    height: 70px;
    vertical-align: middle;

    &:hover{
      border: 6px solid #fff;
      padding: 13px 10px 15px;
    }

    &.el_btn__gray{
      background-color: #4a4a4a;
    }

    &.el_btn__white{
      background-color: #fff;
      border: 1.5px solid #4a495b;
      border-radius: 5px;
      color: #4a495b;

      &:hover{
        border: 2px solid #4a495b;
      }
    }
  }

  .hp_bgColor_5{
    background-color: #7ed321 !important;
    color: #fff !important;
  }
  .hp_bgColor_4{
    background-color: #f57f23 !important;
    color: #fff !important;
  }
  .hp_bgColor_3{
    background-color: #f8e71c !important;
    color: #000 !important;
  }
  .hp_bgColor_2{
    background-color: #bb55d0 !important;
    color: #fff !important;
  }
  .hp_bgColor_1{
    background-color: #ff4f65 !important;
    color: #fff !important;
  }
}

@media screen and (max-width: 768px){
  body {
    font-size: 20px;
  }
  .ly_main{
    height: 100%;
    // padding-top: 103px;

    .ly_mainInner{
      padding-top: 60px;
    }

    .el_btn{
      width: 100%;
      max-width: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue